export const sendPrescriptionViaSms = async (username, toNumber, visitId, getFirestoreRef) => {
  return await getFirestoreRef('outboundSms').add({
    toNumber,
    username,
    visitId,
    timestamp: new Date(),
  })
}
